export const recommendationDismissPeriodLabels = {
  for_seven_days: "for 7 days",
  for_one_month: "for 1 month",
  for_three_months: "for 3 months",
  forever: "",
};
